module.exports = __webpack_public_path__ + "img/outbound--icon.f968e7bb.svg";